const ASC = 'asc'
const DESC = 'desc'

export const sortOrders = Object.freeze({
  ASC,
  DESC,
} as const)

export const sortOrderText = Object.freeze({
  [ASC]: 'Sort A → Z',
  [DESC]: 'Sort Z → A',
} as const)
